import { duration } from '@op/utils/time';
import { transRegion, biggerOrTo } from '../../render-helper';

export default [
  { header: 'Channel', render: 'channel_name' },
  {
    header: 'Poster',
    render: 'reviewer',
  },
  { header: 'Poster URL', render: 'author_url' },
  {
    header: 'Handle Name(Youtube)',
    render: 'author_handle_name',
  },
  {
    header: 'Content',
    render: 'content',
  },
  { header: 'URL', render: 'content_url' },
  {
    header: 'Time(UTC+8:00)',
    render: 'comment_time',
  },
  {
    header: 'Durations',
    render: 'video_detail',
    renderHelper: [
      (item: { [x: string]: any }, key: string | number) => {
        const value = item[key];
        try {
          const info = JSON.parse(value);
          return duration(Number(info.duration), '-');
        } catch (error) {
          return '-';
        }
      },
    ],
  },
  { header: 'Language', render: 'language', renderHelper: [transRegion(3)] },
  {
    header: 'View',
    render: 'view',
    numFmt: '#,##',
    renderHelper: [biggerOrTo(0, '')],
  },
  {
    header: 'Like',
    render: 'tweets_like',
    numFmt: '#,##',
    renderHelper: [biggerOrTo(0, '')],
  },
  {
    header: 'Dislike',
    render: 'tweets_unlike',
    numFmt: '#,##',
    renderHelper: [biggerOrTo(0, '')],
  },
  {
    header: 'Comment',
    render: 'tweets_reply',
    numFmt: '#,##',
    renderHelper: [biggerOrTo(0, '')],
  },

  {
    header: 'Share',
    render: 'tweets_retweet',
    numFmt: '#,##',
    renderHelper: [biggerOrTo(0, '')],
  },
  {
    header: 'Follower/Subscriber',
    render: 'subscribe',
    numFmt: '#,##',
    renderHelper: [biggerOrTo(0, '')],
  },
  {
    header: 'Engagement',
    render: 'engagement',
    numFmt: '#,##',
    renderHelper: [biggerOrTo(0, '')],
  }, 
  {
    header: 'Video Content Sentiment',
    render: 'summary_sentiment',
  },
  {
    header: 'Video Content Summary CN',
    render: 'summary_cn',
  },
  {
    header: 'Video Content Summary EN',
    render: 'summary_en',
  },
  {
    header: 'Description',
    render: 'description',
  },
];
